import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseService } from 'src/app/core/services/base.service';

@Injectable()
export class HomeService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    public hasEvents: BehaviorSubject<boolean> = new BehaviorSubject(true);

    /**
     * getLastNews() - Buscar notícias para sessão de sliders
     *
     */
    getSliders(): Observable<any> {
        // Instacia o body através de BaseSerive.setBody();
        let body = this.setBody();

        // limit: Definir o retorno máximo de últimas notícias
        body.set('limit', '6');
        // session_type: Definir retorno somente de banners de notícias
        body.set('sessionType', '3');

        let response = this.http
            .post(this.urlService + this.routeAdress.route_news_sliders, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    /**
     * getLastNews() - Buscar últimas 6 notícias
     *
     */
    getLastNews(limit: number = 6): Observable<any> {
        // Instacia o body através de BaseService.setBody();
        let body = this.setBody();

        // limit: Definir o retorno máximo de últimas notícias
        body.set('limit', limit);
        // session_type: Definir retorno somente de últimas notícias
        body.set('sessionType', '1');

        let response = this.http
            .post(this.urlService + this.routeAdress.route_news, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    /**
     * getLastVideos() - Buscar últimos 3 videos
     *
     */
    getLastVideos(): Observable<any> {
        // Instacia o body através de BaseService.setBody();
        let body = this.setBody();

        // limit: Definir o retorno máximo de últimos vídeos
        body.set('limit', '3');
        // publishHome: Buscar somente videos para a home
        body.set('publishHome', '1');

        let response = this.http
            .post(this.urlService + this.routeAdress.route_news_videos, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    /**
     * getPartners() - Buscar parceiros/patrociníos
     *
     */
    getPartners(): Observable<any> {
        // Instacia o body através de BaseService.setBody();
        let body = this.setBody();

        // partnerType: Definir retorno somente do tipo de parceria selecionada
        body.set('formatType', '1');

        let response = this.http
            .post(this.urlService + this.routeAdress.route_partners, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    /**
     * getTournaments() - Buscar torneios em destaque
     */
    getFeaturedTournaments(params: GetFeaturedTournamentParams): Observable<any> {
        // Instacia o body através de BaseSerive.setBody();

        let body = this.setBody();

        Object.keys(params).forEach((key) => body.set(key, params[key]));

        let response = this.http
            .post(this.urlService + this.routeAdress.route_tournaments_featured, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    /**
     * Busca cursos e eventos em destaque
     */
    getFeaturedEvents() {
        let body = this.setBody();

        let response = this.http.post(this.urlService + this.routeAdress.route_events_featured, body.toString()).pipe(
            map(this.extractData),
            map((response) => {
                if (response.registers?.length) {
                    this.hasEvents.next(true);
                } else {
                    this.hasEvents.next(false);
                }
                return response;
            }),
            catchError(this.serviceError)
        );

        return response;
    }

    /**
     * Busca rankings em destaque
     */
    getFeaturedRankings(departmentType?: string) {
        let body = this.setBody();
        if (departmentType) {
            body.set('departmentId', departmentType);
        }
        let response = this.http
            .post(this.urlService + this.routeAdress.route_rankings_featured, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    /**
     * Busca campeões
     */
    getFeaturedChampions() {
        let body = this.setBody();

        let response = this.http
            .post(this.urlService + this.routeAdress.route_tournament_get_best_champions, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }
}

export interface GetFeaturedTournamentParams {
    agrupado?: string | number;
    situacao?: string | number;
    departmentType?: string | number;
}

export interface DepartmentFilter {
    descricao: string;
    tipo_depto: string;
    selected: boolean;
}
